import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import { tokens } from "../theme";
import { useTranslation } from "react-i18next";
import LanguageSelector from "./LanguageSelector";

export default function PublicFormPageTopbar() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation('publicForm');

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: colors.primary[400],
        color: colors.grey[100],
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 4,
        py: 2,
        boxShadow: 4,
        borderBottom: `4px solid ${colors.greenAccent[400]}`,
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: "bold", letterSpacing: 0.5 }}
      >
        {t('patientForm')}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography
          variant="body1"
          sx={{
            fontStyle: "italic",
            fontSize: "0.95rem",
            color: colors.greenAccent[300],
          }}
        >
          {t('secureFormSubmission')}
        </Typography>
        
        <LanguageSelector />
      </Box>
    </Box>
  );
}
